<template>
  <div class="harvardIndex" v-show="harvardShow">
    <div class="harvard">
      <!-- 返回 -->
      <span class="gobackBtn" @click="goBack"><img src="./../../../assets/images/icon/back1.png" class="backimg" alt=""></span>
      <!-- 视频 -->
      <div class="header">
        <HFVideo ref="HFVideo" :memberLevel="gread" :videoDetail="videoDetail" isHfindex="true" class="hfvideoclass"></HFVideo>
      </div>
      <!-- 简介 -->
      <div class="videoIntroduction">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;星妈会特邀哈佛大学育儿专家，以更科学的视角讲授五大育儿主题：母乳喂养须知、新生儿养护、宝宝营养攻略、宝宝健康常见问题、宝宝睡眠习惯的培养。育儿不迷茫，更科学的，才是更适合的。</p>
        <div class="noticeBar" v-if="navBarList!=null">
          <img src="./../../../assets/images/activity/harvard/notice.png" alt="">
          <ul class="navBar_list" :class="{navBar_top:animate}">
            <li class="list_item" v-for="(item,index) in navBarList" :key="index">
              <p>恭喜<span class="light_hf">{{formatName(item)}}</span>获得 哈佛育儿课堂 的观看权限</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="expertIntroduction">
        <!-- 专家介绍 -->
        <div>
          <!-- 专家介绍标题 -->
          <div class="expertTitle">
            <img src="./../../../assets/images/activity/harvard/tit1.png" alt="">
            <p>专家介绍</p>
            <img src="./../../../assets/images/activity/harvard/tit2.png" alt="">
          </div>
          <!-- 专家介绍轮播 -->
          <div class="expert_swiper_container">
            <mySwiper :spaceBetweenNum="0" :swipeid="'expert_recommend_swiper'" :loop="false" :slidesNum="0" :paginationFlag="true" :centeredSlides="true" :touchEndFn="touchMoveGio" :list="harvardData.expertList" style="overflow:hidden">
              <div class="swiper-slide" v-for="(item,index) in harvardData.expertList" :key="index" slot="swiper-con">
                <div class="expertHead">
                  <span class="expertImg" :style="{'backgroundImage':'url('+item.imgUrl+')'}"></span>
                  <p class="name">{{item.name}}</p>
                  <p class="hospital">{{item.level}}</p>
                </div>
                <p class="info">{{item.info}}</p>
              </div>
            </mySwiper>
          </div>
        </div>
        <!-- 专题课程 -->
        <div v-if="topicList">
          <div class="expertTitle">
            <img src="./../../../assets/images/activity/harvard/tit1.png" alt="">
            <p>专题课程</p>
            <img src="./../../../assets/images/activity/harvard/tit2.png" alt="">
          </div>
          <p class="slogan">更科学的，才是更适合的</p>
        </div>
        <div v-for="item in topicList" :key="item.id">
          <featuresCard @playCur="playCurVideo" :special="item" :baseParams="{isIndex:true}"></featuresCard>
        </div>
      </div>

      <!-- 分享关注引导 -->
      <share-guide @isAttentFlag="getIsAttention" :imageDetail="videoDetail.videoImg" @shareGio="gioShare" :isHarvard="true"></share-guide>
    </div>
  </div>
</template>

<style lang="less">
@import './../../../assets/less/harvard.less';
.harvardIndex {
  min-height: 100%;
  .harvard {
    min-height: 100%;
  }
  /*
    * 返回按钮样式
    */
  .gobackBtn {
    width: 26px;
    position: fixed;
    top: 7px;
    left: 7px;
    z-index: 999;
    img {
      width: 26px;
      height: 26px;
    }
    .van-icon-arrow-left {
      font-size: @indexFontSize20;
      color: #ffffff;
    }
  }
  min-height: 100%;
  background: #f8f8f8;
  // 先导片
  .header {
    background-image: url(./../../../assets/images/activity/harvard/bg.jpg);
    background-size: 100% 100%;
    height: 309px;
    text-align: -webkit-center;
    position: relative;
    .hfvideoclass {
      width: auto !important;
      height: 191px !important;
      position: absolute !important;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 8% 0;
      z-index: 1;
      border: 8px solid #ffdf00;
      border-radius: 20px;
      box-sizing: border-box;
      z-index: 11;
      box-shadow: 0 0 0 4px #41383f;
      -webkit-box-shadow: 0 0 0 4px #41383f;

      #HF {
        height: 191px !important;
        position: absolute !important;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        margin: auto;
        overflow: hidden;
        background-color: transparent;
        background-color: #ffdf00;
        video {
          border-radius: 10px;
          position: absolute !important;
          bottom: 0;
          left: 0;
          right: 0;
          top: 0;
          margin: auto;
          width: 100% !important;
          margin-top: -1px;
        }
        .xgplayer-controls {
          border-radius: 10px;
        }
        /deep/.xgplayer-poster {
          border-radius: 10px;
          z-index: 0 !important;
        }
      }
      .wifi {
        width: 299px !important;
        margin: 0 auto;
        height: 175px !important;
        border-radius: 10px;
        top: 0 !important;
        left: 0 !important;
      }
    }
  }
  // 视频简介
  .videoIntroduction {
    background: @color255;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.05);
    padding: 19px 17px 17px 17px;
    p {
      font-size: @fontSize12;
      color: @color133;
      padding-bottom: 14px;
    }
    .noticeBar {
      width: 100%;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background: #f0f0f0;
      color: @color51;
      display: block;
      position: relative;
      overflow: hidden;
      img {
        float: left;
        width: 16px;
        height: 16px;
        padding: 8px 12px 7px 24px;
      }
      .navBar_list {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        .list_item {
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          padding-left: 50px;
          p {
            width: 270px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            .light_hf {
              color: @colorY2;
              margin: 0 5px;
            }
          }
        }
      }
      .navBar_top {
        transition: all 0.5s;
        margin-top: -30px;
      }
    }
  }
  // 专家介绍
  .expertIntroduction {
    // 专家介绍标题
    .expertTitle {
      padding-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 25px;
        height: 15px;
        padding-top: 3px;
      }
      img:last-child {
        width: 30px;
        height: 15px;
      }
      p {
        font-size: @fontSize18;
        font-weight: bold;
        color: @color51;
        padding: 0 5px;
      }
    }
    .slogan {
      font-size: @fontSize12;
      color: @color204;
      text-align: center;
      padding-bottom: 10px;
    }
    // 专家介绍轮播
    .expert_swiper_container {
      height: 183px;
      overflow: hidden;
    }
  }
}
</style>

<script>
import API from "./../../../utils/axiosApi/harvardApi";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import featuresCard from "@/components/activity/harvard/featuresCard.vue";
import HFVideo from '@/components/activity/harvard/HFVideo.vue';
import shareGuide from "@/components/common/shareGuide.vue";
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import harvardData from './../../../utils/mockData/harvardData';
import { getCookie, is_weixin } from "@/assets/js/common.js";
// 引入哈佛视频微信分享公共方法
import hfwxJsSet from './../../../assets/js/HFwxConfig.js'
export default {
  name: "harvardIndex",
  data () {
    return {
      animate: false,
      harvardData: harvardData,//哈佛专家
      navBarList: null,
      topicList: null,
      videoDetail: {
        "videoUrl": "https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/coa-funeng/coa/40/b2a3996e-b757-4c75-b3bc-2c0f9ec40e32.mp4",
        "videoImg": "https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/coa-funeng/coa/41/cfd06840-0644-4182-89ce-b5d52b58d246.JPG",
        "locked": false,
        "videoDuration": "1:10",
        "videoSize": "18.42"
      },
      harvardShow: false,
      memberLevel: "未登录",
      gread: null,
      scrollWatch: true,
      scrollTop: null,
      source: this.$route.query.source
    }
  },
  components: {
    featuresCard, HFVideo, shareGuide, mySwiper
  },
  //      beforeRouteLeave(to, from, next) {
  //     if (to.name == "home") {
  //      from.meta.scrollTop = 10000
  //      console.log(from.meta.scrollTop)
  //     }
  //     next();
  //   },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit("changeIncludes", ["home", "harvardIndex"]);
      if (vm.is_weixin()) {
        if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          var userInfo = localStorage.getItem('userInfo');
          if (!userInfo) {
            // 有openid获取用户信息
            var userOpenid = vm.getCookie('xmh_openid');
            API.goLogin({}, { openId: userOpenid }, res => {
              if (res.code == "200") {
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                gio('setUserId', res.data.crm_id);
                sensors.login(res.data.crm_id)
                vm.getUserLevel();
              } else {
                vm.openHomeGio();
              }
            })
          } else {
            vm.getUserLevel();
            gio('setUserId', JSON.parse(userInfo).crm_id);
            sensors.login(JSON.parse(userInfo).crm_id)
          }
          vm.initPageFn();
        }
      } else {
        vm.harvardShow = true;
        vm.getNoticeList();
        vm.getAllTopicVideos();
      }
    })
  },
  mounted () {
    var shareUrl = this.$route.query.pageSource ? location.origin + "/harvard?pageSource=" + this.$route.query.pageSource + "&shareFrom=wxHfShare" : location.origin + "/harvard?shareFrom=wxHfShare";
    var shareDataParams = {
      shareLink: shareUrl.split('#')[0],
      shareDesc: "星妈会特邀哈佛大学育儿专家，陪您一路升级打怪，科学养娃！",
      shareTitle: "哈佛育儿",
      imgUrl: "https://image-mom.feihe.com/wxshare/hafoyuer.png"//必须是绝对路径
    };
    hfwxJsSet.wxShare(shareDataParams, this, res => {
      this.$toast({
        duration: 2000,
        message: "分享成功",
        context: this,
        className: "toastZIndex"
      })
    });
    if (this.scrollWatch) {
      window.addEventListener('scroll', this.handleScroll);
    }



  },
  beforeRouteLeave (to, from, next) {
    this.scrollWatch = false
    window.removeEventListener('scroll', this.handleScroll);
    next()
  },
  watch: {
    scrollTop: {
      handler () {
        this.handleScroll()
      }
    },
    topicList (val) {
      console.log(val, 'topicList')
      localStorage.setItem("hfVideo", JSON.stringify(val))
    }
  },
  methods: {
    handleScroll () {
      this.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let top1 = $('.harvardIndex').offset().top;
      let top2 = $(document).scrollTop();
      let top = top1 - top2;
      if (this.scroll > top1) {
        let t1 = 0;
        let t2 = 0;
        let timer2 = null; // 定时器
        document.onscroll = function () {
          clearTimeout(timer2);
          timer2 = setTimeout(isScrollEnd, 300);
          t1 = document.documentElement.scrollTop || document.body.scrollTop;
        }
        function isScrollEnd () {
          t2 = document.documentElement.scrollTop || document.body.scrollTop;
          var path;
          if (t2 == t1) {
            path = require('./../../../assets/images/icon/back1.png')
            $(".backimg").attr('src', path);
          } else {
            path = require('./../../../assets/images/icon/back2.png')
            $(".backimg").attr('src', path);
          }
        }
      }
    },
    // 初始化
    initPageFn: function () {
      this.harvardShow = true;
      this.getNoticeList();
      this.getAllTopicVideos();
    },
    //返回到上一页面
    goBack () {
      if (this.$route.query.source == 'mine') {
        this.$router.push("/mine");
      } else {
        if (window.history.length > 1 && this.getCookie("fromPath")) {
          this.$router.go(-1);
        } else {
          this.$router.push({ path: '/home' });
        }
      }
    },
    // 获取滚动公告
    getNoticeList: function () {
      API.getNoticeList({}, res => {
        if (res.code == "200") {
          this.navBarList = res.data;
          if (this.navBarList) {
            setInterval(this.navBar, 3000);
          }
        }
      });
    },
    // 通知栏滚动
    navBar: function () {
      if (this.navBarList && this.navBarList.length != 1) {
        this.animate = true;
        setTimeout(() => {
          this.navBarList.push(this.navBarList[0]);
          this.navBarList.shift();
          this.animate = false;
        }, 500);
      }
    },
    // 获取专题列表
    getAllTopicVideos: function () {
      API.getAllTopicVideo({}, res => {
        if (res.code == "200") {
          this.topicList = res.data;
        }
      })
    },
    playCurVideo: function (id) {
      var pageSource = "class";
      if (this.$route.query.pageSource) pageSource = this.$route.query.pageSource;
      this.$router.push({ path: "/harvard/" + id + "?pageSource=" + pageSource + '&source=' + this.source })
    },
    // 初始化用户昵称
    formatName: function (name) {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (name && name.length > 6) {
        if (myreg.test(name)) {
          return name.slice(0, 3) + "**" + name.slice(7, 11);
        } else {
          return name.slice(0, 2) + "**" + name.slice(name.length - 2, name.length);
        }
      } else {
        return name
      }
    },
    //获取用户是否关注了星妈会
    getIsAttention: function (val) {
      if (this.is_weixin() && this.$route.query.shareFrom && this.$route.query.shareFrom == "wxHfShare") {
        if (!val) {
          API.newUser({}, { openId: this.getCookie("xmh_openid"), fnVideoId: 3238 }, res => { });
        }
      }
    },
    getUserLevel: function () {
      API.getUserGrade({}, { crmId: JSON.parse(localStorage.getItem('userInfo')).crm_id }, res => {
        if (res.code == "200") {
          this.gread = res.data;
          this.memberLevel = res.data.grade.name;
          this.openHomeGio();
        }
      });
    },
    getCookie, is_weixin,
    // 首页打开页面埋点
    openHomeGio: function () {
      var pageSource = this.$route.query.pageSource, pageSourceName = "星妈课堂";
      switch (pageSource) {
        case "tweets":
          pageSourceName = "推文";
          break;
        case "xmhfirstconcern":
          pageSourceName = "首关";
          break;
        case "poster":
          pageSourceName = "海报";
          break;
        case "zhdg":
          pageSourceName = "智慧导购";
          break;
        case "brand":
          pageSourceName = "品牌电商";
          break;
        case "xmhtab":
          pageSourceName = "星妈会菜单";
          break;
        case "fhnftab":
          pageSourceName = "飞鹤奶粉菜单";
          break;
        default:
          pageSourceName = "星妈课堂";
          break;
      };
      if (this.gread && (JSON.parse(localStorage.getItem('userInfo')).mobile != "" || JSON.parse(localStorage.getItem('userInfo')).mobile != null || JSON.parse(localStorage.getItem('userInfo')).mobile != "null")) {
        gio('page.set', { 'pageSource': pageSourceName, 'login_evar': '已登录', 'member_level': this.memberLevel });
      } else {
        gio('page.set', { 'pageSource': pageSourceName, 'login_evar': '未登录', 'member_level': '未登录' });
      }
    },
    // Gio点击分享按钮埋点
    gioShare: function () {
      gio('track', 'hafohome_share', { 'member_level': this.memberLevel });
    },
    //哈佛首页-专家信息滑动
    touchMoveGio: function (e) {
      gio('track', 'hafohome_expert');
    }
  }
}
</script>
